import React from 'react';
import {
  Briefcase, CheckCircle, AlertCircle, Clock,
  CheckCheck, ShieldAlert, XCircle
} from 'lucide-react';

const STATES = {
  all: { label: 'All', color: '#64748b', bg: 'rgba(100,116,139,0.12)', icon: <Briefcase size={12}/> },
  assigned: { label: 'Assigned', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)', icon: <CheckCircle size={12}/> },
  in_progress: { label: 'In Progress', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', icon: <AlertCircle size={12}/> },
  awaiting_confirmation: { label: 'Awaiting Confirm', color: '#06b6d4', bg: 'rgba(6,182,212,0.12)', icon: <Clock size={12}/> },
  completed: { label: 'Completed', color: '#10b981', bg: 'rgba(16,185,129,0.12)', icon: <CheckCheck size={12}/> },
  raise_dispute: { label: 'Dispute', color: '#ef4444', bg: 'rgba(239,68,68,0.12)', icon: <ShieldAlert size={12}/> },
  cancelled: { label: 'Cancelled', color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: <XCircle size={12}/> },
};

export default STATES;